module.exports = require( './lib/whet.extend' );


//////////////////
// WEBPACK FOOTER
// ./~/whet.extend/index.js
// module id = 343
// module chunks = 0